import { PapiEditorText } from '@wix/da-papi-types';

export enum CustomExclusiveFieldName {
  TITLE = 'title',
  DESCRIPTION = 'description',
  MATURE_CONTENT = 'matureContent',
  NO_AI = 'noAi',
  IS_AI_GENERATED = 'isAiGenerated',
  PRICE = 'price',
  TAGS = 'tags',
  DELIVERY_TIME = 'deliveryTime',
  DISPLAY_RESOLUTION = 'displayResolution',
  ADD_WATERMARK = 'addWatermark',
}

export interface CustomExclusiveFormFields {
  [CustomExclusiveFieldName.TITLE]: string;
  [CustomExclusiveFieldName.DESCRIPTION]: string;
  [CustomExclusiveFieldName.MATURE_CONTENT]: boolean;
  [CustomExclusiveFieldName.NO_AI]: boolean;
  [CustomExclusiveFieldName.IS_AI_GENERATED]: boolean;
  [CustomExclusiveFieldName.PRICE]: number;
  [CustomExclusiveFieldName.TAGS]: string[];
  [CustomExclusiveFieldName.DELIVERY_TIME]: number;
  [CustomExclusiveFieldName.DISPLAY_RESOLUTION]: string;
  [CustomExclusiveFieldName.ADD_WATERMARK]: boolean;
}

export enum QuestionFieldName {
  QUESTION = 'question',
  ANSWER_TYPE = 'answerType',
  ANSWER_CHOICES = 'answerChoices',
  IS_REQUIRED = 'isRequired',
}

export interface QuestionFormFields {
  [QuestionFieldName.QUESTION]: any;
  [QuestionFieldName.ANSWER_TYPE]: AnswerType;
  [QuestionFieldName.IS_REQUIRED]: boolean;
  [QuestionFieldName.ANSWER_CHOICES]?: AnswerChoice[];
}

export enum AnswerType {
  FREE_TEXT = 'free-text',
  SINGLE_CHOICE = 'single-choice',
  MULTIPLE_CHOICE = 'multiple-choice',
}

export interface AnswerChoice {
  answerText: string;
  price?: number;
}

export interface Question {
  id: string;
  questionBody: PapiEditorText;
  answerType: AnswerType;
  isRequired: boolean;
  answerChoices?: AnswerChoice[];
}
